// ---------------------------------------------------------------------------
// Leitura dos 422 ESTRUTURADOS por item (handoff 0107 §5, 2026-09-10).
//
// O backend devolve uma violação por item problemático em `errors[]`, com
// campos extras por code (`prod_id`, `shipped_qtd`, `remaining_qtd`,
// `received_qtd`…). O FC1 preserva a lista em `apiError.errorItems`; aqui ela
// vira um mapa indexado por `prod_id` — as telas indexam as linhas por
// prod_id, então NADA de parsear mensagem.
//
// Violações sem `prod_id` (ex.: a de `version`) ficam fora do mapa — quem
// trata conflito de versão lê `errorItems` direto pelo `code`.
// ---------------------------------------------------------------------------

export function itemErrorsByProdId(apiError) {
   const map = {};
   (apiError?.errorItems ?? []).forEach((entry) => {
      if (entry?.prod_id == null) return;
      map[entry.prod_id] = entry;
   });
   return map;
}
